import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

export default function PageShell({ title, subtitle, eyebrow, children, accent = "blue" }) {
  const accents = {
    blue:   "from-[#0e4a7a] via-[#1d6cb1] to-[#2a83ce]",
    purple: "from-[#3b0764] via-[#6b21a8] to-[#a21caf]",
    amber:  "from-[#92400e] via-[#d97706] to-[#f59e0b]",
    rose:   "from-[#9d174d] via-[#be185d] to-[#ec4899]",
    emerald:"from-[#065f46] via-[#047857] to-[#10b981]",
  };
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50/40 via-white to-white">
      <Header />
      <section className={`relative overflow-hidden bg-gradient-to-br ${accents[accent] || accents.blue} text-white`}>
        <div className="absolute inset-0 opacity-30" style={{backgroundImage:'radial-gradient(circle at 25% 20%, white 0%, transparent 35%), radial-gradient(circle at 75% 80%, white 0%, transparent 35%)'}}/>
        <div className="relative max-w-6xl mx-auto px-4 py-12 sm:py-16 text-center">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/15 border border-white/30 text-xs font-bold uppercase tracking-wider mb-3">
              {eyebrow}
            </div>
          )}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold drop-shadow-md" style={{fontFamily:"'Playfair Display', serif"}}>
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 max-w-3xl mx-auto text-sm sm:text-base text-white/90 leading-relaxed">{subtitle}</p>
          )}
        </div>
      </section>
      <main className="max-w-6xl mx-auto px-4 py-12">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
